// Wix media URL resolver — safe in both server and client components
// (no 'server-only' marker). Converts `wix:image://v1/<id>...` URIs to the
// CDN URL the browser can load; http(s) URLs pass through untouched.

export function wixMediaUrlClient(s: string | undefined): string | undefined {
  if (!s) return undefined;
  if (s.startsWith('http://') || s.startsWith('https://')) return s;
  if (s.startsWith('wix:image://v1/')) {
    const rest = s.slice('wix:image://v1/'.length);
    const fileId = rest.split('#')[0].split('/')[0];
    return fileId ? `https://static.wixstatic.com/media/${fileId}` : undefined;
  }
  return undefined;
}

const WIX = 'https://static.wixstatic.com/media/';

/**
 * A sized Wix CDN URL (server-side resize + auto avif/webp). Accepts a bare
 * media URL or one that already carries a /v1/... transform; anything not on
 * the Wix CDN (e.g. /lookbook/*) passes through untouched. With `h` the image
 * is cropped to exactly w×h (fill); without it, fit within w×2w.
 */
export function wixSized(src: string, w: number, h?: number, quality = 80): string {
  if (!src.startsWith(WIX)) return src;
  const id = src.slice(WIX.length).split('/')[0];
  const ext = /\.png$/i.test(id) ? 'png' : 'jpg';
  const size = `w_${w},h_${h ?? w * 2}`;
  const mode = h ? 'fill' : 'fit';
  return `${WIX}${id}/v1/${mode}/${size},q_${quality},enc_auto/file.${ext}`;
}

/** srcSet for a Wix image cropped to a fixed aspect (`ratio` = height / width). */
export function wixSrcSet(src: string, widths: number[], ratio: number): string | undefined {
  if (!src.startsWith(WIX)) return undefined;
  return widths.map((w) => `${wixSized(src, w, Math.round(w * ratio))} ${w}w`).join(', ');
}
